<div class="task-tabs-row">
  <nav class="task-tabs">
    @for (tab of tabs(); track tab.id) {
      <button class="task-tab" [class.active]="activeTab() === tab.id" (click)="tabChanged.emit(tab.id)">
        {{ tab.label }}
        <pill size="small" [color]="activeTab() === tab.id ? 'primary' : 'gray'" [value]="tab.count"></pill>
      </button>
    }
  </nav>

  <label class="task-search">
    <aiwyn-icon name="search" class="task-search-icon icon-color-gray-500" [height]="16" [width]="16"></aiwyn-icon>
    <input
      type="search"
      class="task-search-input"
      placeholder="Search tasks..."
      [value]="searchQuery()"
      [dataSelector]="'cxp-task-list-search'"
      (input)="onSearchInput($event)"
    />
  </label>
</div>

@for (task of tasks(); track task.key) {
  <div
    class="task-card"
    role="button"
    tabindex="0"
    [attr.aria-label]="task.name"
    (click)="taskSelected.emit(task)"
    (keydown)="onCardKeydown($event, task)"
  >
    <div class="task-card-center">
      @if (getCardMeta(task); as meta) {
        <span class="task-card-meta">{{ meta }}</span>
      }
      <span class="task-name">
        <span class="color-gray-200">
          @switch (task.type) {
            @case ('external-deliverable') {
              Review your return:
            }
            @case ('deliverable') {
              Review Deliverable:
            }
            @case ('esign-client-request-list') {
              E-Sign:
            }
            @default {
              Provide information:
            }
          }
        </span>

        {{ getTaskTitle(task) }}
      </span>
      
      @if (task.description) {
        <span class="task-description" [innerHTML]="task.description | sanitizedHtml"></span>
      }
      @if (task.progress; as progress) {
        <div class="task-progress">
          <div class="task-progress-track">
            <div class="task-progress-fill" [style.width.%]="getProgressPercent(progress)"></div>
          </div>
          <span class="task-progress-label">{{ progress.completed }}/{{ progress.total }}</span>
        </div>
      }
      <div class="task-card-pills">
        @if (task.serviceLine; as serviceLine) {
          <pill size="small" color="gray" [value]="serviceLine.name"></pill>
        }
        @if (task.actionRequired) {
          <pill size="small" color="red" value="Action Required"></pill>
        }
        @if (getIntegrationIcon(task); as integrationIcon) {
          <img
            class="task-integration-logo"
            [src]="integrationIcon.assetPath"
            [alt]="integrationIcon.label"
            [title]="integrationIcon.label"
            [dataSelector]="'cxp-task-list-integration-logo'"
          />
        }
      </div>
    </div>

    <div class="task-card-end">
      @if (task.dueDate) {
        <span class="task-date">Due {{ task.dueDate | safeDate: 'MMM d, yyyy' }}</span>
      } @else if (task.createdAt) {
        @if (task.type === 'client-request-list' || task.type === 'external-client-request-list' || task.type === 'esign-client-request-list') {
          <!--
            Client-request-list rows always show the "Due" prefix even
            when we're falling back to createdAt (no real dueDate from
            backend yet) — matches the original design intent that
            request lists are deadline-driven. Deliverable rows show
            just the date in the fallback case.
          -->
          <span class="task-date">Due {{ task.createdAt | safeDate: 'MMM d, yyyy' }}</span>
        } @else {
          <span class="task-date">{{ task.createdAt | safeDate: 'MMM d, yyyy' }}</span>
        }
      }
      @if (task.type === 'client-request-list') {
        <button andButton color="default" size="small">{{ getCtaLabel(task) }}</button>
      } @else if (task.type === 'deliverable') {
        <button andButton color="default" size="small" [dataSelector]="'cxp-task-list-deliverable-view'">View</button>
      } @else if (task.type === 'external-deliverable') {
        <button andButton color="default" size="small" [dataSelector]="'cxp-task-list-external-deliverable-view'">View</button>
      } @else if (task.type === 'external-client-request-list') {
        <button andButton color="default" size="small" [dataSelector]="'cxp-task-list-external-client-request-list-view'">View</button>
      } @else if (task.type === 'esign-client-request-list') {
        @if (getEsignSignerStatusLabel(task); as signerStatus) {
          <span class="task-esign-signer-status" [dataSelector]="'cxp-task-list-esign-signer-status'">{{ signerStatus }}</span>
        }
        <!--
          `Start` on an open row, not `Review & Sign`: that label belongs to the signature
          block on the detail page, one step further in. The shared CTA map is not used
          because its other labels key off request-list item progress, which an eSign
          bundle shell has none of.
        -->
        <button andButton color="default" size="small" [dataSelector]="'cxp-task-list-esign-view'">
          @if (task.status === 'completed') {
            View
          } @else {
            Start
          }
        </button>
      }
    </div>
  </div>
}

@if (!isLoading() && tasks().length === 0) {
  <div class="task-list-empty">
    @if (activeTab() === 'open') {
      <h2 class="task-list-empty-heading">You're all caught up</h2>
      <p class="task-list-empty-body">No tasks need your attention right now.</p>
    } @else {
      <h2 class="task-list-empty-heading">No completed tasks</h2>
      <p class="task-list-empty-body">Tasks you complete will appear here.</p>
    }
  </div>
}
